<template>
  <div class="block">
    <!-- 所屬年份 -->
    <div class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>所屬年份</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <v-autocomplete
          :items="yearOptions"
          v-model="shareholderDividendHistory.year"
          placeholder="請選擇年份"
          class="w-240px"
          item-text="name"
          item-value="id"
          outlined
          dense
        >
        </v-autocomplete>
      </div>
    </div>
    <!-- 股東會日期 -->
    <div class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>股東會日期</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <v-menu
          v-model="meetingDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="shareholderDividendHistory.meeting_date"
              placeholder="請選擇日期"
              outlined
              dense
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="shareholderDividendHistory.meeting_date"
            @input="meetingDateMenu = false"
          >
            <v-btn text color="primary"
                   @click="shareholderDividendHistory.meeting_date = null">
              清除
            </v-btn>
          </v-date-picker>
        </v-menu>
      </div>
    </div>
    <!-- 現金股利 -->
    <div class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>現金股利</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <v-text-field
          v-model="shareholderDividendHistory.cash"
          type="number"
          outlined
          dense
        ></v-text-field>
      </div>
    </div>
    <!-- 除息交易日 -->
    <div class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>除息交易日</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <v-menu
          v-model="exDividendDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="shareholderDividendHistory.ex_dividend_date"
              placeholder="請選擇日期"
              outlined
              dense
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="shareholderDividendHistory.ex_dividend_date"
            @input="exDividendDateMenu = false"
          >
            <v-btn text color="primary"
                   @click="shareholderDividendHistory.ex_dividend_date = null">
              清除
            </v-btn>
          </v-date-picker>
        </v-menu>
      </div>
    </div>
    <!-- 盈餘配股 -->
    <div class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>盈餘配股</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <v-text-field
          v-model="shareholderDividendHistory.sre"
          type="number"
          outlined
          dense
        ></v-text-field>
      </div>
    </div>
    <!-- 除權交易日 -->
    <div class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>除權交易日</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <v-menu
          v-model="exRightDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="shareholderDividendHistory.ex_right_date"
              placeholder="請選擇日期"
              outlined
              dense
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="shareholderDividendHistory.ex_right_date"
            @input="exRightDateMenu = false"
          >
            <v-btn text color="primary"
                   @click="shareholderDividendHistory.ex_right_date = null">
              清除
            </v-btn>
          </v-date-picker>
        </v-menu>
      </div>
    </div>
    <!-- 公積配股 -->
    <div class="form-item pt-5 d-flex">
      <div class="w-240px mr-5">
        <h4>盈餘配股</h4>
      </div>
      <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
        <v-text-field
          v-model="shareholderDividendHistory.scap"
          type="number"
          outlined
          dense
        ></v-text-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data: () => ({
    meetingDateMenu: false,
    exDividendDateMenu: false,
    exRightDateMenu: false,
  }),
  computed: {
    ...mapState('shareholderDividendHistory', ['shareholderDividendHistory']),
    yearOptions() {
      const startYear = 1991;
      const range = new Date().getFullYear() - startYear + 1;
      return [...Array(range).keys()].map((i) => i + startYear);
    },
  },
};
</script>

<style></style>
